import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/home.mp4")